export default __webpack_public_path__ + "static/media/HeroLogoWhite.7b8678be.png";